// extracted by mini-css-extract-plugin
module.exports = {"root":"PendingPaymentAlert_root___I7zT","buttons":"PendingPaymentAlert_buttons__3k_6X"};